import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import * as User from '../../utils/userHelpers';
import * as Utils from '../../utils/utils';
import * as Cart from '../../utils/cartHelper';
import * as TokenHelpers from '../../utils/tokenHelpers';
import * as UserActions from '../../actions/userActions';
import WineIcon from '../../assets/images/wine.svg';
import BeerIcon from '../../assets/images/beer.svg';
import LiquorIcon from '../../assets/images/liquor.svg';
import ExtrasIcon from '../../assets/images/extras.svg';
// import WineIconActive from '../../assets/images/wine-gray.svg';
// import BeerIconActive from '../../assets/images/beer-gray.svg';
// import LiquorIconActive from '../../assets/images/liquor-gray.svg';
// import ExtrasIconActive from '../../assets/images/extras-gray.svg';
import HeaderTop from '../../components/commons/header/HeaderTop';
import HeaderMiddle from '../../components/commons/header/HeaderMiddle';
import HeaderBottom from '../../components/commons/header/HeaderBottom';
import MegaMenu from '../../components/commons/header/MegaMenu';
import ToggleSwitch from './ToggleSwitch';

import * as FBinit from '../../utils/fbintit';
const MainMenuSet = {
  'wines': {
    name: 'Wine',
    icon: WineIcon,
    activeIcon: WineIcon,
    megaMenu: {}
  },
  'beers': {
    name: 'Beer',
    icon: BeerIcon,
    activeIcon: BeerIcon,
    megaMenu: {}
  },
  'liquor': {
    name: 'Liquor',
    icon: LiquorIcon,
    activeIcon: LiquorIcon,
    megaMenu: {}
  },
  'extras': {
    name: 'Extras',
    icon: ExtrasIcon,
    activeIcon: ExtrasIcon,
    megaMenu: {}
  }
}

class Header extends Component {

  constructor(props) {
    super(props);

    this.state = {
      megaMenuVisibility: false,
      activeMenu: '',
      settingsMenuVisibility: false,
      checked: false,
    }
    this.setActiveMenu = this.setActiveMenu.bind(this);
    this.buildMenuCollection = this.buildMenuCollection.bind(this);
    this.handleOnClickMouseEvents = this.handleOnClickMouseEvents.bind(this);
    this.onSettingsMenuClick = this.onSettingsMenuClick.bind(this);
    this.updateCart = this.updateCart.bind(this);
    this.handleToggleSwitch = this.handleToggleSwitch.bind(this);
  }

  componentDidMount() {

    this.handleOnClickMouseEvents();
    if(User.isLoggedIn()) {
      this.props.dispatch(UserActions.getProfileDetails());

      let cartProductsCount = Cart.getProductsCount();
      this.setState({productsCount: cartProductsCount});
    }
    window.addEventListener('cart_changed', this.updateCart)
  }

  render() {

    console.log('HEADER_STATE', this.state);
    //console.log('HEADER_PROPS', this.props);
    const {activeMenu, megaMenuVisibility, settingsMenuVisibility, productsCount} = this.state;
    const MenuSet = this.buildMenuCollection();
    const user = Utils.toJS(this.props.user);
    const departments = Utils.toJS(this.props.departments);
    return (
      <div className={`header`}>
        <HeaderTop loggedUser={user} onSettingsMenuClick={this.onSettingsMenuClick} settingsMenuVisibility={settingsMenuVisibility} toggleSettingsMenu={() => this.setState({
          settingsMenuVisibility: !settingsMenuVisibility
        })} productsCount={productsCount}/>
        {/* <ToggleSwitch id="switch" checked={this.state.checked} onChange={this.handleToggleSwitch} /> */}
        <HeaderMiddle loggedUser={user}/>
        <HeaderBottom
          mainMenuSet={MenuSet}
          departments= {departments}
          activeMenu={activeMenu}
          setActiveMenu={this.setActiveMenu} megaMenuVisibility={megaMenuVisibility} />
          <div className={`header-bottom`}>
          <div className={`container`}>
          <div className={`row`}>
          <div className={`col-md-12 py-3`}> <h3 className={`text-center`}>CHOOSE AN ADDRESS TO SHOW PRICES</h3></div>
          <div className={`container-fluid d-flex  flex-column pb-2`}
          ><ToggleSwitch id="switch" checked={this.state.checked} onChange={this.handleToggleSwitch} user={user} props={this.props}/></div></div></div></div>
          
        
      </div>
    )
  }

  handleToggleSwitch(e) {
    console.log("toggle switch");
    this.setState({
      checked: !this.state.checked
    })
  }

  setActiveMenu(currentMenuId) {
    const {megaMenuVisibility, activeMenu} = this.state;
    this.setState({
      megaMenuVisibility: !(activeMenu === currentMenuId && megaMenuVisibility),
      activeMenu: activeMenu === currentMenuId && megaMenuVisibility
        ? ''
        : currentMenuId
    })

    // console.log('HEADER_PROPS', this.props);
     console.log('HEADER_STATE', this.state);
  }

  onSettingsMenuClick(action) {

    switch (action) {
      case 'profile':
        break;
      case 'logout':
        this.props.dispatch(UserActions.resetUserData());
        TokenHelpers.destroy();
        Cart.clearCart();

        FBinit.FBlogout();
        break;
    }
    this.setState({settingsMenuVisibility: false})
  }

  handleOnClickMouseEvents(excludedTargets = [], includedtargets = []) {

    document.body.addEventListener('click', (me) => {
      const MainNav = ReactDOM.findDOMNode(this).getElementsByClassName('main-nav');
      const MegaMenus = ReactDOM.findDOMNode(this).getElementsByClassName('mega-menu');
      const targets = [
        ...MegaMenus,
        ...MainNav
      ];
      let isMenuElement = false;
      targets.map(target => {
        if (target.contains(me.target))
          isMenuElement = true;
        }
      )
      if (!isMenuElement)
        this.setState({activeMenu: ''})
    }, true);
  }

  buildMenuCollection() {

    const departments = Utils.toJS(this.props.departments);
    let menuSet = MainMenuSet;

    if (!departments) {
      console.warn('departments not loaded yet')
      return;
    }

    departments.map(department => {
      let mainMenuKey = '';
      switch (department.dep) {
        case 'WHITE WINE':
        case 'SPARKLING WINE':
        case 'RED WINE':
        case 'ROSE WINE':
          mainMenuKey = 'wines'
          break;
        case 'LIQUOR':
          mainMenuKey = 'liquor'
          break;
        case 'BEER':
          mainMenuKey = 'beers'
          break;
        case 'MIXERS & SUPPLIES':
        case 'PHARMACY & MORE':
        case 'TOBACCO':
        case 'SNACKS':
          mainMenuKey = 'extras'
          break;
        default:
          mainMenuKey = ''
      }
      if (mainMenuKey && menuSet[mainMenuKey])
        menuSet[mainMenuKey]['megaMenu'][department.dep] = department.cat;
      else
        console.warn("menu [" + mainMenuKey + "] not found")
    })
    //console.log("MEGA_MENU_SET", menuSet);
    return menuSet;
  }

  updateCart(e) {
    let cartProductsCount = Cart.getProductsCount();
    console.log("CART_PRODUCTS_COUNT", cartProductsCount);
    this.setState({productsCount: cartProductsCount});
  }

}

export default connect((state) => {
  return {
    user: state.getIn(['users', 'user']),
    departments: state.getIn(['products', 'departments'])
  };
})(Header);



// WEBPACK FOOTER //
// ./src/containers/commons/Header.js